import { Routes } from '@angular/router';
import { translateRoutes } from "@app/_core/router-utility";


export const NewCertificatesRoutes: Routes = translateRoutes([
  {
    path: '',
    loadComponent: () =>
      import('./certificates-document-check-detail.component').then(
        (mod) => mod.NewCertificatesDocumentCheckDetailComponent,
      ),
  },
])
